<template>

  <!-- Google Tag Manager (noscript) -->
  <noscript v-if="GTM_ID">
    <iframe :src="`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
  </noscript>
  <!-- End Google Tag Manager (noscript) -->
  <RouterView/>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { createStructuredData } from '@/utils/createStructuredData.ts'

const GTM_ID: string | undefined = import.meta.env.VITE_GTM_ID

const structuredData = createStructuredData(GTM_ID)
useHead(structuredData)
</script>

<style scoped>

</style>